import { useState } from 'react';

export const useTableSelection = (allItems: any[], idProperty: string) => {
  const [isTableHeadChecked, setIsTableHeadChecked] = useState(false);
  const [selectedIndividualCheckboxId, setSelectedIndividualCheckboxId] = useState<any[]>([]);
  const [selectedItemData, setSelectedItemData] = useState<any>({});

  const updateSelection = (isChecked: boolean, item: any) => {
    const itemId = item[idProperty];

    setSelectedIndividualCheckboxId((prevItems) => {
      const updatedIds = new Set(prevItems);

      if (isChecked) {
        updatedIds.add(itemId);
      } else {
        updatedIds.delete(itemId);
      }

      const updatedArray = Array.from(updatedIds);

      if (updatedArray.length === 0) {
        setSelectedItemData({});
      } else if (updatedArray.length === 1) {
        const remainingItem = allItems?.find((i: any) => i[idProperty] === updatedArray[0]);
        setSelectedItemData(remainingItem);
      } else if (!isChecked && updatedArray.length > 1) {
        // Remove item from selectedItemData if it is unselected and more than one item is still selected
        setSelectedItemData({});
      } else {
        setSelectedItemData(item);
      }

      setIsTableHeadChecked(updatedArray.length === allItems?.length);
      return updatedArray;
    });
  };

  const handleTableHeadChange = (e: any) => {
    const isChecked = e.target.checked;
    setIsTableHeadChecked(isChecked);

    if (isChecked) {
      const allItemsIds = allItems?.map((data: any) => data[idProperty]) || [];
      setSelectedIndividualCheckboxId(allItemsIds);
      
    } else {
      setSelectedIndividualCheckboxId([]);
    }
  };

  const handleCheckItem = (e: any, item: any) => {
    updateSelection(e.target.checked, item);
  };

  const handleRowClick = (item: any) => {
    
    const itemId = item[idProperty];

    const isSelected = selectedIndividualCheckboxId.includes(itemId);
    
    updateSelection(!isSelected, item);
  };
  const handleRowClickedById = (itemId: string | number) => {
  const item = allItems.find((i) => i[idProperty] === itemId);
  if (!item) return;

  const isSelected = selectedIndividualCheckboxId.includes(itemId);
  updateSelection(!isSelected, item);
};
  const handleRowDoubleClick = (item: any) => {
    const itemId = item[idProperty];
    const isSelected = selectedIndividualCheckboxId.includes(itemId);    
    updateSelection(!isSelected, item);
    // setSelectedIndividualCheckboxId([itemId]);
  };
  const handleDelete = (itemId: string) => {
    setSelectedIndividualCheckboxId((prevItems) => {
      const updatedIds = prevItems.filter(id => id !== itemId); 
      setIsTableHeadChecked(updatedIds.length === allItems.length);
      return updatedIds;
    });
  
    // If the deleted item was the selected one, clear selectedItemData
    setSelectedItemData((prevData:any) => {
      return prevData[idProperty] === itemId ? {} : prevData;
    });
  };
  
  return {
    isTableHeadChecked,
    selectedIndividualCheckboxId,
    selectedItemData,
    handleTableHeadChange,
    handleCheckItem,
    handleRowClick,
    handleRowDoubleClick,
    handleDelete,
    handleRowClickedById,
    setSelectedIndividualCheckboxId,
    setIsTableHeadChecked,
    setSelectedItemData
  };
};
